import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomValidator {

  static required(isRequired: boolean) {
    const validator = (formControl: FormControl) => {

      if (!formControl.root || !(<FormGroup>formControl.root).controls) {
        return null
      }
      if (isRequired) {
        let value = formControl.value;
        return (value === null || value === undefined || value === '') ? { 'required': true } : null;
      }

      return null;
    }
    return validator
  }


  static equalsTo(otherField: any) {
    const validator = (formControl: FormControl) => {

      if (!formControl.root || !(<FormGroup>formControl.root).controls) {
        return null
      }

      const field = (<FormGroup>formControl.root).get(otherField)

      if (field?.value !== formControl.value) {
        return { equalsTo: false }
      }
      return null
    }
    return validator
  }

  static validateCep(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const cep = control.value;

      let cepCompare = cep?.split('').map(Number)
      let isAllNumbersEqual = true

      cepCompare?.forEach(
        (element: any) => {
          if (cepCompare[0] != element) {
            isAllNumbersEqual = false
          }
        }
      )

      if (cep && cep !== '') {

        if (isAllNumbersEqual) {
          return { cepInvalido: true }
        }

        const validateCep = /^[0-9]{8}$/;
        return validateCep.test(cep) ? null : { cepInvalido: true }

      } else {
        return null
      }


    }

  }

  static validateTaxId(): ValidatorFn {

    return (control: AbstractControl): ValidationErrors | null => {
      const cpf = String(control.value);
      const cpfCompare = cpf.split('').map(Number);
      let isAllNumberEqual: boolean = true
      if(cpfCompare.length < 11 || cpf == null){
        return {taxId: false};
      }


      cpfCompare.forEach(
        (element) => {
          if (element != cpfCompare[0]) {
            isAllNumberEqual = false
          }
        }
      )

      if (cpf && cpf !== '' && cpf.length == 11 && !isAllNumberEqual) {
        let noveDigitos = String(cpf.slice(0, 9));
        let arrayCPF = noveDigitos.split('').map(Number);

        let primeiroDigitoVerificador: number = 0;
        let segundoDigitoVerificador: number = 0;

        let peso = 10;
        let soma = 0;

        /* regra para primeiro digito verificador */

        for (let i = 0; i < 9; i++) {
          soma += arrayCPF[i] * peso;
          peso--;
        }

        if (soma % 11 === 0 || soma % 11 === 1) {
          primeiroDigitoVerificador = 0;
        } else {
          primeiroDigitoVerificador = 11 - (soma % 11);
        }

        /* regra para segundo digito verificador */

        arrayCPF.push(primeiroDigitoVerificador);

        soma = 0;
        peso = 11;

        for (let i = 0; i < 10; i++) {
          soma += arrayCPF[i] * peso;
          peso--;
        }

        if (soma % 11 == 0 || soma % 11 == 1) {
          segundoDigitoVerificador = 0;
        } else {
          segundoDigitoVerificador = 11 - (soma % 11);
        }

        arrayCPF.push(segundoDigitoVerificador);

        /* comparando os digitos */

        if (arrayCPF[9] === cpfCompare[9] && arrayCPF[10] === cpfCompare[10]) {
          return null;
        } else {
          return { taxId: true };
        }
      } else {
        return { taxId: true };
      }

    }
  }

  static validateDate(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let date = control.value
      
      date = date?.replace(/\//g, "")

      if (date && date !== '') {

        if (date.length !== 8) {
          return { dateInvalid: false }
        }

        let dia = parseInt(date.substring(0, 2), 10);
        let mes = parseInt(date.substring(2, 4), 10);
        let ano = parseInt(date.substring(4, 8), 10);

        if (
          (dia < 1 || dia > 31) ||
          (mes < 1 || mes > 12) ||
          (ano < 1000 || ano > 9999)
        ) {
          return { dateInvalid: false }
        } else {
          return null
        }

      } else {
        return null
      }
    }

  }

  static validateCNPJ(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let cnpjString = control.value
      let cnpjArray = cnpjString?.split("").map(Number);
      if(cnpjArray?.length < 11 || cnpjString == null){
        return null;
      }

      let primaryDigitVerifier;
      let secondaryDigitVerifier;
      let egualsNumbers = true;

      cnpjArray?.forEach((element: any) => {
        if(element != cnpjArray[0]){
          egualsNumbers = false
        }
      })  

      if(!cnpjString || cnpjString == '' || egualsNumbers) {
        return { cnpj: true }
      }

      let primarySum = (
        (cnpjArray[11] * 2) +
        (cnpjArray[10] * 3) +
        (cnpjArray[9] * 4) +
        (cnpjArray[8] * 5) +
        (cnpjArray[7] * 6) +
        (cnpjArray[6] * 7) +
        (cnpjArray[5] * 8) +
        (cnpjArray[4] * 9) +
        (cnpjArray[3] * 2) +
        (cnpjArray[2] * 3) +
        (cnpjArray[1] * 4) +
        (cnpjArray[0] * 5)
      )

      if (
        (primarySum % 11 == 0) ||
        (primarySum % 11 == 1)
      ) {
        primaryDigitVerifier = 0
      } else {
        primaryDigitVerifier = 11 - (primarySum % 11)
      }

      let secondSum = (
        (primaryDigitVerifier * 2) +
        (cnpjArray[11] * 3) +
        (cnpjArray[10] * 4) +
        (cnpjArray[9] * 5) +
        (cnpjArray[8] * 6) +
        (cnpjArray[7] * 7) +
        (cnpjArray[6] * 8) +
        (cnpjArray[5] * 9) +
        (cnpjArray[4] * 2) +
        (cnpjArray[3] * 3) +
        (cnpjArray[2] * 4) +
        (cnpjArray[1] * 5) +
        (cnpjArray[0] * 6)
      )

      if (
        (secondSum % 11 == 0) ||
        (secondSum % 11 == 1)
      ) {
        secondaryDigitVerifier = 0
      } else {
        secondaryDigitVerifier = 11 - (secondSum % 11)
      }

      if (
        (cnpjArray[12] == primaryDigitVerifier) &&
        (cnpjArray[13] == secondaryDigitVerifier)
      ) {
        return null
      } else {
        return { cnpj: true }
      }

    }
  }

  static validateAgeGroup():ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      console.log(control.value)
      return null
     }
  }

  static validateContactNumber(): ValidatorFn {
    return(control: AbstractControl): ValidationErrors | null => {
      let phoneNumber = control.value

      if(!phoneNumber){
        return null
      }

      if(phoneNumber.length == 10 && phoneNumber[2] == 9){
        return { phoneNumberInvalid: true }
      }

      if(phoneNumber.length == 11 && phoneNumber[2] != 9){
        return { phoneNumberInvalid: true }
      }

      return null
    }
  }


}
